import { RemitRecord } from "us.collection.economy/components/Remit/Interfaces";

export const DEFAULT_CREDITOR_DETAIL:RemitRecord ={
  id: "0",
  creditorNo: "",
  creditorName: "",
  creditorAmount: 0,
  bureauAmount: 0,
  debtorAmount: 0,
  otherAmount: 0,
  vatAmount: 0,
  vatPaidByDebtor: 0,
  vatDeducted: 0,
  otherDeducted: 0,
  remitCreditor: 0,
  remitBureau: 0,
  remitDebtor: 0,
  totalAmount: 0,
  vatDeductedOld: 0,
}
